// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Sonic Universe - Warp Gates Configuration
 * 
 * Speed Rings connecting the Sonic Universe to other dimensions.
 */

export const warpGates = [
  {
    id: 'gate_sonicuniverse_to_marioworld',
    name: 'Warp Ring Portal',
    type: 'warpgate',
    description: 'A giant golden ring that warps you to a world of pipes and plumbers. Gotta go fast to the Mushroom Kingdom!',
    distance: 25, // Distance from Green Hill Zone
    destinationUniverse: 'marioworld',
    destinationGate: 'gate_marioworld_to_sonicuniverse',
    toSystem: 1000, // Mushroom Kingdom
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'WARP RING GATEWAY',
    services: [],
    primaryColor: '#FFCC00',
    secondaryColor: '#FF0000',
    hasRings: true,
    animated: true
  },
  {
    id: 'gate_sonicuniverse_to_pokemon',
    name: 'Ring Portal',
    type: 'warpgate',
    description: 'Golden rings lead to a world of pocket monsters. Gotta go fast to catch them all!',
    distance: 28, // Distance from Green Hill Zone
    destinationUniverse: 'pokemon',
    destinationGate: 'gate_pokemon_to_sonicuniverse',
    toSystem: 600, // Kanto Prime
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'WARP RING GATEWAY',
    services: [],
    primaryColor: '#0066FF',
    secondaryColor: '#FFD700',
    hasRings: true,
    animated: true
  },
  {
    id: 'gate_sonicuniverse_to_zelda',
    name: 'Triforce Gateway',
    type: 'warpgate',
    description: 'Triforce Gateway - A mystical portal glowing with ancient magic. Speed meets legend.',
    distance: 24, // Distance from Green Hill Zone
    destinationUniverse: 'zelda',
    destinationGate: 'gate_zelda_to_sonicuniverse',
    toSystem: 1200, // Hyrule Kingdom
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'TRIFORCE ENERGY PORTAL',
    services: [],
    primaryColor: '#0066FF',
    secondaryColor: '#FFD700',
    hasRings: true,
    animated: true
  }
];

// Warp gate positions for map visualization
export const warpGatePositions = {
  'gate_sonicuniverse_to_marioworld': { x: 25, y: 45, z: 5 },   // Near Green Hill Zone
  'gate_sonicuniverse_to_pokemon': { x: 40, y: 60, z: 5 },      // 28 LY from Green Hill Zone
  'gate_sonicuniverse_to_zelda': { x: 35, y: 50, z: 5 }         // 24 LY from Green Hill Zone
};